import './Details-8093044f.css';

var classes = {"Details":"prc-Details-Details-XJobb"};

export { classes as default };
